export default __webpack_public_path__ + "static/media/rkdatta_image_2.b1c46911.svg";